import React from 'react';
import Cookies from 'js-cookie';

const UserCertificateDisplay = ({ items, mapping, certificadoId }) => {

    if (items != null) {
      return (
        <>
          {/* <AlphabetList /> */}
          {items.map((item, index) => {
    return (
      <tr key={item.id} className="table-row">
        <td className="table-cell">
          <button
            type="button"
            className="empresa-button"
            onClick={() => {
  
              localStorage.setItem('certificado', JSON.stringify(item));  
              window.location.href = `/${mapping}/certificates/certificado?idProducto=${item.idProducto}&certificadoId=${certificadoId}`;
            }}
          >
            {item.modelo}-{item.idProducto}
          </button>
        </td>
      </tr>
    );
  })}
        </>
      );
    }
  }
  
  export default UserCertificateDisplay; 